import { Controller } from "@hotwired/stimulus"

// Makes an /apps card/row navigate on any click that isn't on one of its real
// interactive descendants (links, form controls, media players, and actions).
export default class extends Controller {
    static values = { url: String }

    navigate(event) {
        if (event.target.closest("a, button, form, input, select, textarea, video, audio, summary, .assistant-header-menu")) return
        if (window.getSelection().toString().length > 0) return

        window.location.href = this.urlValue
    }
}
